import { render, staticRenderFns } from "./VideoDemoList.vue?vue&type=template&id=50dec2be"
import script from "./VideoDemoList.vue?vue&type=script&lang=js"
export * from "./VideoDemoList.vue?vue&type=script&lang=js"
import style0 from "./VideoDemoList.vue?vue&type=style&index=0&id=50dec2be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports